<template>
  <SettingsModal
    :headline="$t(`licensedterritory.${licensedTerritory}`)"
    icon="location"
    :tracking="{
      action: 'state_switch',
      topicKey: 'state_selection',
      customMessage: trackingOptions,
      customTopic: $t(`licensedterritory.${licensedTerritory}`),
    }"
    @close="emit('close')"
  >
    <div>
      <LcSelectList v-bind="{ options }" v-model:value="modelValue" />
    </div>

    <template #footer>
      <div class="-my-100 -mr-100">
        <LanguageSwitch @option-click="emit('close')" />
      </div>
    </template>
  </SettingsModal>
</template>

<script lang="ts" setup>
import type { LcSelectListOption } from '@lottocom/frontend-components'

const { licensedTerritory, options } = useStateSwitch()

const emit = defineEmits<{ (e: 'close'): void }>()

const modelValue = computed({
  get: () => licensedTerritory,
  set: (newValue: LcSelectListOption['value']) => {
    if (newValue) return
    emit('close')
  },
})

const trackingOptions = computed(() => options.value.map(({ label }) => label).join(', '))
</script>
